export default __webpack_public_path__ + "assets/attach_icon.svg";